export default {
  navigation: {
    brand: 'Rootsence',
    links: {
      marketplace: 'Marketplace',
      pricing: 'Pricing',
      blog: 'Blog',
    },
    buttons: {
      getStarted: 'Get Started',
      openMenu: 'Open Menu',
      closeMenu: 'Close Menu',
    },
  },
  mainContent: {
    targetUsers: 'Target Users: Non-technical creators, operations personnel, knowledge workers',
    titles: {
      first: "The world's first Vibe Workflow platform",
      second: 'Configure AI workflows as easily as chatting',
    },
    description:
      'Describe your needs as if chatting with a friend, and users can effortlessly build their own AI workflows.',
    buttons: {
      getStarted: 'Get Started',
    },
  },
  pageContent: {
    subtitle: 'Transform your creative ideas into efficient automated workflows.',
    mission: {
      title: 'Showcasing the irreplaceable knowledge reserves within each individual',
      description:
        "Whether it's the efficient work techniques you've developed through trial and error or the unique expertise you've cultivated in your field, AI can transform them into practical templates that are both shareable and monetizable.",
    },
    ceoSection: {
      automatedWorkflows: 'AUTOMATED WORKFLOWS',
    },
  },
  pageStat: {
    title: 'Choose the right tools = Double your efficiency',
    description: 'Three Core Highlights, Unlocking a New Era of Efficient Automation',
    cards: [
      {
        title: 'Get started in five minutes—no coding required',
        description:
          'No programming experience required—build your first automated workflow in just 5 minutes.',
      },
      {
        title: 'Covering 90% of everyday work scenarios',
        description:
          'One-stop solutions for automation deployment, process optimization, and business scaling across the entire lifecycle',
      },
      {
        title: 'Creator Economy: Monetize by Sharing',
        description:
          "Publish your exclusive workflow, and every time someone uses it, you'll earn tangible rewards.",
      },
    ],
  },
  pageList: {
    title: 'One-stop automated workflow creation platform',
    description: 'Template Reuse & Publishing Solution: Earn Revenue Instantly',
    feature: 'Features',
    cards: [
      {
        title: 'AI Copilot',
        description:
          'Describe requirements in natural language to automatically generate complete workflows.',
      },
      {
        title: 'Visual execution',
        description:
          'Each step is clearly visible as it executes, with real-time display of status and results.',
      },
      {
        title: 'Smart Node',
        description: 'Each node is an AI agent that automatically understands context.',
      },
      {
        title: 'Multithreaded Dialogue',
        description: 'Manage multiple sessions independently to avoid context confusion.',
      },
    ],
  },
  pageOption: {
    title: 'Market Competition and Differentiation',
    description: 'All the features you need for automated processes, right here.',
    tabs: [
      {
        title: 'Compared to Dify',
        points: [
          'Designed for automating daily tasks, get started in 5 minutes',
          'Real-time multi-user collaboration (CRDT), similar to Google Docs.',
          'Creator Monetization Ecosystem: Earn 20% revenue by publishing templates.',
        ],
      },
      {
        title: 'Compared to n8n',
        points: [
          'No programming required—build workflows with natural language.',
          '2 nodes vs 10+ nodes: a huge efficiency gap.',
          'Smart Node: Each node is an AI Agent',
        ],
      },
    ],
  },
  pageGroup: {
    title: 'Application Scenarios and User Groups',
    description: 'Meet the needs of different user groups',
    groups: [
      {
        title: 'Content Creator',
        description: 'Self-media operations, video creation, blog writing',
      },
      {
        title: 'Operations personnel',
        description: 'Account Management, Data Collection, Client Communication',
      },
      {
        title: 'Researchers',
        description:
          'Academic literature curation, industry intelligence tracking, knowledge base management',
      },
      {
        title: 'Small teams/startups',
        description: 'Marketing Automation, Customer Support, Internal Process Optimization',
      },
    ],
  },
  pageSlide: {
    title: 'Seamlessly integrate with 3000+ tools',
    description:
      'Zero configuration, no barriers, no complex operations Automatically handles 90% of your daily tasks',
  },
  pageCombo: {
    title: 'Frequently Asked',
    description: 'Quickly view answers to frequently asked questions',
    faqs: [
      {
        question: 'What kind of product is AIMfly?',
        answer:
          "Leverage the power of AI to effortlessly automate repetitive tasks, build personalized workflows, and reuse high-quality templates. It's an indispensable smart partner for creators and high-performing teams.",
      },
      {
        question: 'Does using AIMfly require technical skills?',
        answer:
          'Absolutely not. You can intuitively build workflows, use existing templates, or let Copiot generate them for you. No coding required.',
      },
      {
        question: 'Is my data secure in AIMfly?',
        answer:
          'Yes. Your data is absolutely private. All connected tools adhere to the OAuth security authentication mechanism, and we take data protection very seriously.',
      },
      {
        question: 'How do I package my work into a template?',
        answer:
          'Once approved, your workflow will be listed on the template marketplace. An outstanding workflow can help you attract more followers.',
      },
      {
        question: 'Which document formats are supported?',
        answer:
          'Supports presentations (PPT/PDF), documents (Word/Markdown/PDF), spreadsheets (Excel/CSV), project plans, meeting minutes, and more. All outputs are production-ready and fully formatted.',
      },
    ],
  },
  pageSubscribe: {
    title: 'Subscribe',
    description: 'Please select your subscription plan.',
    plans: [
      {
        title: 'Free Plan',
        subtitle: 'The perfect starting point for your creative journey',
        price: '$ 0 /month',
        features: ['100 points daily', 'Suitable for testing simple workflows'],
        button: 'Free',
        highlight: false,
      },
      {
        title: 'Starter Plan',
        subtitle: 'Upgrade your plan to unlock more benefits',
        price: '$ 24.9 /month',
        features: ['300 points daily + 2,000 points monthly', 'Access a vast library of tools'],
        button: 'Activate Now',
        highlight: false,
      },
      {
        title: 'Maker Program',
        subtitle: 'Upgrade your plan to unlock more benefits',
        price: '$ 49.9 /month',
        features: [
          '300 points daily + 2,000 points monthly',
          'Access a vast library of tools',
          'Service Support: Premium Priority Support',
        ],
        button: 'Activate Now',
        highlight: true,
      },
      {
        title: 'Corporate Plan',
        subtitle: 'Upgrade your plan to unlock more benefits',
        price: 'Exclusively Customized',
        features: ['Coming soon, stay tuned'],
        button: 'Coming soon',
        highlight: false,
      },
    ],
  },
  pageContact: {
    title: 'Contact Us',
    form: {
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      nameRequired: 'Please enter your name',
      phone: 'Phone',
      phonePlaceholder: 'Please enter your phone number',
      email: 'Email',
      emailPlaceholder: 'Please enter your email',
      emailRequired: 'Please enter your email',
      wechat: 'WeChat',
      wechatPlaceholder: 'Please enter your WeChat',
      message: 'Message',
      messagePlaceholder: 'Please enter your thoughts and suggestions',
      consent:
        'To provide you with a more personalized experience, we may use your provided information to improve our services',
      button: 'Book an Experience',
      submitSuccess: 'Submit success! We will contact you soon.',
      submitFailed: 'Submit failed. Please try again.',
      submitError: 'An error occurred. Please try again later.',
    },
  },
  pageInvite: {
    subtitle: 'AI-Driven + Multi-Tool Integration',
    title: 'Simple and smart workflow',
    tagline: 'Create · Publish · Earn',
    button: 'Get Started',
  },
};
